import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as ReviewActionItemTypesActions from '../review-action-item-types/review-action-item-types.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class ReviewActionItemTypesStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new ReviewActionItemTypesActions.ReviewActionItemTypesRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.REVIEW_ACTION_ITEM_TYPES, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new ReviewActionItemTypesActions.ReviewActionItemTypesCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new ReviewActionItemTypesActions.ReviewActionItemTypesUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new ReviewActionItemTypesActions.ReviewActionItemTypesDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new ReviewActionItemTypesActions.ReviewActionItemTypesRefresh());
          break;
      }
    });
  }
}
